import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import axiosInstance from "../../api/axiosInstance";
import { delay } from "../../helper/delayresponse";

interface SmsCampaignListReports {
    id?: number;
    name: string,
    numbers: File[],
    message: string,
    retries: number,
    schedule_time: string,
    status?: number;
    createdAt?: string;
    updatedAt?: string;
}

interface SmsCampaignListReportsState {
    smscampaignlistreportdata: SmsCampaignListReports[];
    info: { count: number; current_page: number; limit: number; total_page: number } | null;
    error: string | null;
    loading: boolean;
}


// ====================-SmsCampgain-listing-action-start==============
export const GetallSmsCampaignListReports = createAsyncThunk<
    { data: SmsCampaignListReports[], info: { count: number; current_page: number; limit: number; total_page: number } },
    { search: string; page: number; limit: number },
    { rejectValue: string }
>(
    'smscampaignlistreportdata',
    async ({ search, page, limit }, { rejectWithValue }) => {
        try {
            await delay(1000)
            const response = await axiosInstance.get(`api/admin/sms-campaign/lists`, {
                params: { search, page, limit },
            });
            return { data: response.data.data, info: response.data.info };
        } catch (error: any) {
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data);
            }
            return rejectWithValue(error.message);
        }
    }
);
// ====================SmsCampgain-listing-action-start==============

const initialState: SmsCampaignListReportsState = {
    smscampaignlistreportdata: [],
    info: null,
    error: null,
    loading: false,
};

const smscampaignlistreportsSlice = createSlice({
    name: "Smscampaignlistreports",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // ===============get-all-smtp-slice-start============
            .addCase(GetallSmsCampaignListReports.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(GetallSmsCampaignListReports.fulfilled, (state, action: PayloadAction<{ data: SmsCampaignListReports[], info: { count: number; current_page: number; limit: number; total_page: number } }>) => {
                state.loading = false;
                state.smscampaignlistreportdata = action.payload.data;
                state.info = action.payload.info;
            })
            .addCase(GetallSmsCampaignListReports.rejected, (state, action: PayloadAction<string | undefined>) => {
                state.loading = false;
                state.error = action.payload || 'An error occurred';
            });
        // ===============get-all-smtp-slice-end============

    },
});

export default smscampaignlistreportsSlice.reducer;